<template>
  <div>
    <!-- Modal Logo Size Options -->
    <b-form-group
      id="input-group-3"
      label="Logo Size:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.modalLogoSize"
        :options="form.settings.logoSizeOptions"
        required
      />
    </b-form-group>
    <!-- / Modal Logo Size Options -->

    <!-- Modal Size -->
    <b-form-group
      id="input-group-3"
      label="Modal Size:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.modalSize"
        :options="form.settings.modalSizeOptions"
        required
      />
    </b-form-group>
    <!-- / Modal Size -->

    <!-- Modal Border Width Options -->
    <b-form-group
      id="input-group-3"
      label="Modal Border Width:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.modalBorderStyle"
        :options="form.settings.modalBorderWidthOptions"
        required
      />
    </b-form-group>
    <!-- / Modal Size -->

    <!-- Modal Border Radius Options -->
    <b-form-group
      id="input-group-3"
      label="Modal Border Radius:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.modalBorderRadius"
        :options="form.settings.modalBorderRadiusOptions"
        required
      />
    </b-form-group>
    <!-- / Modal Border Radius Options -->

    <!-- Submit Button Type -->
    <b-form-group
      id="input-group-3"
      label="Submit Button Type:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.submitType"
        :options="form.settings.submitButtonTypeOptions"
        required
      />
    </b-form-group>
    <!-- / Submit Button Type -->

    <!-- Submit Button Style -->
    <b-form-group
      id="input-group-3"
      label="Submit Button Style Options:"
      label-for="input-3"
    >
      <b-form-select
        id="input-3"
        v-model="form.values.submitStyle"
        :options="form.settings.submitButtonStyleOptions"
        required
      />
    </b-form-group>
    <!-- / Submit Button Style Options -->
  </div>
</template>

<script>
import formMixin from '../../../mixins/form-mixin'

export default {
  name: 'design-form',
  mixins: [formMixin],
  data: () => {
    return {
      gate: 'age-gate-new',
      form: {
        settings: {
          modalSizeOptions: [
            {
              text: 'Medium',
              value: 'md'
            },
            {
              text: 'Large',
              value: 'lg'
            },
            {
              text: 'Extra Large',
              value: 'xl'
            }
          ],
          logoSizeOptions: [
            {
              text: 'Small',
              value: 'small'
            },
            {
              text: 'Medium',
              value: 'medium'
            },
            {
              text: 'Large',
              value: 'large'
            }
          ],
          modalBorderWidthOptions: [
            {
              text: 'None',
              value: 'none'
            },
            {
              text: 'Small',
              value: 'small'
            },
            {
              text: 'Medium',
              value: 'medium'
            },
            {
              text: 'Large',
              value: 'large'
            }
          ],
          modalBorderRadiusOptions: [
            {
              text: 'None',
              value: 'none'
            },
            {
              text: 'Small',
              value: 'small'
            },
            {
              text: 'Medium',
              value: 'medium'
            },
            {
              text: 'Large',
              value: 'large'
            }
          ],
          submitButtonTypeOptions: [
            {
              text: 'Text',
              value: 'text'
            },
            {
              text: 'Underlined Text',
              value: 'text-underline'
            },
            {
              text: 'Square',
              value: 'square'
            },
            {
              text: 'Rounded',
              value: 'rounded'
            },
            {
              text: 'Pill',
              value: 'pill'
            }
          ],
          submitButtonStyleOptions: [
            {
              text: 'Solid (can not be used with a text button type.)',
              value: 'solid'
            },
            {
              text: 'Outlined',
              value: 'outline'
            }
          ],
          submitButtonIcon: [
            {
              text: 'Arrow',
              value: 'arrow'
            },
            {
              text: 'Tail Arrow Right',
              value: 'tail-arrow-right'
            },
            {
              text: 'Tail Arrow Down',
              value: 'tail-arrow-down'
            },
            {
              text: 'Triangle Right',
              value: 'triangle-right'
            },
            {
              text: 'External Link',
              value: 'external-link'
            },
            {
              text: 'Loading Circle',
              value: 'loading-circle'
            },
            {
              text: 'Loading Circle Gradient',
              value: 'loading-circle-gradient'
            }
          ]
        },
        values: {
          modalSize: 'lg', // don't go below md use, md, l g ot xl
          modalLogoSize: 'medium',
          theme: { // expect that the data / combinations will change here
            mainTheme: 'museum',
            subsetTheme: 'light-accent-1',
            subsetContrastTheme: 'type-1'
          },
          modalBorderStyle: 'large',
          modalBorderRadius: 'small',
          submitType: 'pill',
          submitStyle: 'solid',
          submitSize: 'standard',
          submitIcon: ''
        }
      }
    }
  },
  computed: {
    styleSettings() {
      return this.$store.getters['sitegate/styleSettings']('age-gate-new')
    }
  },
  mounted() {
    this.$set(this.form, 'values', this.styleSettings)
  }
}
</script>
